import React from 'react'
import './Footer.css'
import { getFrontendAssetUrl } from '../../lib/frontendAssets'

const logo = getFrontendAssetUrl('LOGO_FONS_TRANSPARENT.png');
const instagramLogo = getFrontendAssetUrl('instagram.png');
const gmailLogo = getFrontendAssetUrl('gmail.png');
const telefonLogo = getFrontendAssetUrl('tlf.png');
const whatsappLogo = getFrontendAssetUrl('whats.png');

/*hr serveix per posar linea horitzontal i fer separció de continguts */
/* target=_blank significa que s'obrira nova finestra per mostrar enllaç */

const Footer = () => {
  return (
    <footer className='footer' id='Contacte'>
        <hr className='first-hr'/> 
        <div className='footer-logo'>
            <img src={logo} alt="" style ={{width: '70px', height: '70px'}}/>
            <p>Equips Oficina Anoia</p>
        </div>
        <ul className='footer-links'>
            <li>
              <a href='https://www.instagram.com/' target='_blank' rel='noreferrer'>
                <img src={instagramLogo} alt='' style ={{width: '35px', height: '35px'}}/>
              </a>
              <p> @equipsoficina</p>
            </li>
            <li>
              <a href='https://gmail.com/' target='_blank' rel='noreferrer'>
                <img src={gmailLogo} alt='' style ={{width: '45px', height: '45px'}} className='gmail-footer'/>
              </a>
              <p>equips.oficina@gmail.com</p>
            </li>
            <li>
              <img src={telefonLogo} alt='' style ={{width: '35px', height: '35px'}}/>
              <p> 93 803 24 49</p>
            </li>
            <li>
              <a href='https://web.whatsapp.com/' target='_blank' rel='noreferrer'>
                <img src={whatsappLogo} alt='' style ={{width: '35px', height: '35px'}}/>
                </a>
              <p> 686 409 572</p>
            </li>
        </ul>
        <div className='footer-copyright'>
          <hr /> 
          <p>Copyright @ 2024 - All Right Reserved</p>
        </div>
    </footer>
  )
}

export default Footer
